export default __webpack_public_path__ + "static/media/accenturelabs.faebb666.png";